import Breadcrumbs from "components/Common/Breadcrumb"
import FullPageLoader from "components/fullPageLoader"
import downloadIcon from "../../../assets/images/download.png"
import pdfIcon from "../../../assets/images/icons/file-type.svg"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { useLazyGetDocumentsQuery } from "store/api/investors/reports.api"
import { useSelector } from "react-redux"

const Documents = () => {
  const [trigger, { isFetching }] = useLazyGetDocumentsQuery()
  const [documents, setDocuments] = useState([])
  const { userType } = useSelector((state) => state.user)

  const getDocuments = async () => {
    try {
      const { data } = await trigger({
        user_type: userType === "INVESTOR" ? "investor" : "wealthPartner",
      }).unwrap()
      setDocuments(data)
    } catch (error) {}
  }

  useEffect(() => {
    getDocuments()
  }, [userType])

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Draft Documents"} breadcrumbItem={"Documents"} />

          <Row>
            <Col xl={12}>
              {isFetching ? (
                <FullPageLoader />
              ) : (
                <Card>
                  <CardBody>
                    <div className="playlist-wrapper-section">
                      {documents.map((item, index) => (
                        <div
                          key={`document_${index}`}
                          className="playlist-card-box text-center "
                        >
                          <div className="align-self-center text-center">
                            <img src={pdfIcon} alt="Download PDF" />
                          </div>
                          <p
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              marginTop: "14px",
                              marginBottom: "14px",
                            }}
                          >
                            {item.title}
                          </p>

                          <span className="floating-labels">
                            *These documents are for the ready reference
                          </span>
                          <div
                            style={{
                              textAlign: "center",
                              marginTop: "10px",
                              marginBottom: "14px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              color: "#09518C",
                            }}
                          >
                            <a
                              href={item.document_url}
                              className="d-flex flex-column play-icon"
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#09518C", fontSize: "16px" }}
                            >
                              Download
                            </a>

                            <img height={"20px"} src={downloadIcon} />
                          </div>
                          {/* <button className="btn btn-primary w-md btn btn-secondary">
                            
                          </button> */}
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Documents
